import { VStack, Text, Heading } from '@chakra-ui/react';

// interface StepHeaderProps {
//     currentStep: number;
//     totalSteps: number;
//     title: string;
//     subtitle?: string;
// }

const StepHeader = ({ title, subtitle }) => {
    return (
        <VStack spacing={4} mb={8}>
            {title && (
                <Heading variant="headline">
                    {title}
                </Heading>
            )}
            {subtitle && (
                <Heading variant="subHeadline">
                    {subtitle}
                </Heading>
            )}
        </VStack>
    );
};

export default StepHeader;